import { categories } from "../../../mocks/hotNews";
import SectionHeading from "./SectionHeading";

interface ColumnsProps {
  onPickCategory: (name: string) => void;
}

export default function Columns({ onPickCategory }: ColumnsProps) {
  return (
    <section id="columns" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="栏目分类"
          title="挑个喜欢的坑，前排入座"
          desc="六大栏目各有各的热闹，无论你想围观娱乐名场面、科技新梗还是社会风向，都能找到对味的现场。"
        />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <button
              key={c.name}
              type="button"
              onClick={() => onPickCategory(c.name)}
              className="group flex flex-col items-center gap-3 rounded-2xl border border-background-200 bg-background-100/50 p-5 text-center transition-all hover:-translate-y-1 hover:border-primary-200 hover:bg-background-50"
            >
              <img
                src={c.cover}
                alt={`${c.name}栏目现场：${c.desc}`}
                title={`${c.name} - 看料门栏目`}
                className="h-28 w-full rounded-xl object-cover object-center md:h-36"
              />
              <div>
                <div className="flex items-center justify-center gap-1.5">
                  <i className={`${c.icon} text-lg text-primary-500`}></i>
                  <span className="text-sm font-bold text-foreground-900">{c.name}</span>
                </div>
                <p className="mt-1 text-[11px] leading-relaxed text-foreground-500">{c.desc}</p>
                <p className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-medium text-primary-600">
                  {c.count} <i className="ri-arrow-right-up-line"></i>
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}